import { WeekStartDay } from '@retailer-platform/shared-components/src/tds'

export enum DimensionTypes {
  TimeInterval,
  Program,
  Entity,
  Info,
}

export enum TimeIntervalDimensions {
  DATE_PT = 'DATE_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  WEEK_TUE_PT = 'WEEK_TUE_PT',
  WEEK_WED_PT = 'WEEK_WED_PT',
  WEEK_THU_PT = 'WEEK_THU_PT',
  WEEK_FRI_PT = 'WEEK_FRI_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  MONTH_PT = 'MONTH_PT',
}

export const WeekStartDayToDateDimension: Record<WeekStartDay, TimeIntervalDimensions> = {
  [WeekStartDay.Sunday]: TimeIntervalDimensions.WEEK_SUN_PT,
  [WeekStartDay.Monday]: TimeIntervalDimensions.WEEK_MON_PT,
  [WeekStartDay.Tuesday]: TimeIntervalDimensions.WEEK_TUE_PT,
  [WeekStartDay.Wednesday]: TimeIntervalDimensions.WEEK_WED_PT,
  [WeekStartDay.Thursday]: TimeIntervalDimensions.WEEK_THU_PT,
  [WeekStartDay.Friday]: TimeIntervalDimensions.WEEK_FRI_PT,
  [WeekStartDay.Saturday]: TimeIntervalDimensions.WEEK_SAT_PT,
}
